$(document).ready(function () {
    'use strict';

    $('.js_openTimesToggle').on('click', function () {
        $(this).toggleClass('open');
        $(this).next('.openingTimes').slideToggle();
    });
})